import { render, staticRenderFns } from "./FreeDemo.vue?vue&type=template&id=7a286631&"
import script from "./FreeDemo.vue?vue&type=script&lang=ts&"
export * from "./FreeDemo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports